
const IconHex = () => null;

export default IconHex;
